"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtrarLogs = exports.filtrarPermissoes = exports.funcoesPadrao = void 0;
const funcoesPadrao = (group, descricao, setor, groupLog) => {
    return {
        Incluir: {
            chaves: { group, role: 1 },
            chavesLog: groupLog ? { group: groupLog, role: 1 } : undefined,
            acao: `Incluiu registro ${descricao}`,
            descricao: `Incluir registro ${descricao}`,
            setor,
        },
        Alterar: {
            chaves: { group, role: 2 },
            chavesLog: groupLog ? { group: groupLog, role: 2 } : undefined,
            acao: `Alterou registro ${descricao}`,
            descricao: `Alterar registro ${descricao}`,
            setor,
        },
        Excluir: {
            chaves: { group, role: 3 },
            chavesLog: groupLog ? { group: groupLog, role: 3 } : undefined,
            acao: `Excluiu registro ${descricao}`,
            descricao: `Excluir registro ${descricao}`,
            setor,
        },
        Relatórios: {
            chaves: { group, role: 4 },
            chavesLog: groupLog ? { group: groupLog, role: 4 } : undefined,
            acao: `Acessou relatórios ${descricao}`,
            descricao: `Acessar relatórios ${descricao}`,
            setor,
        },
    };
};
exports.funcoesPadrao = funcoesPadrao;
const filtrarPermissoes = (permissionLogs) => {
    const resultado = {};
    for (const [conjunto, atividades] of Object.entries(permissionLogs)) {
        const atividadesFiltradas = {};
        for (const atividade in atividades) {
            if (atividades[atividade].chaves) {
                atividadesFiltradas[atividade] = atividades[atividade];
            }
        }
        if (Object.keys(atividadesFiltradas).length > 0) {
            resultado[conjunto] = atividadesFiltradas;
        }
    }
    return resultado;
};
exports.filtrarPermissoes = filtrarPermissoes;
const filtrarLogs = (permissionLogs) => {
    const resultado = {};
    for (const [conjunto, atividades] of Object.entries(permissionLogs)) {
        const atividadesFiltradas = {};
        for (const atividade in atividades) {
            if (atividades[atividade].chavesLog) {
                atividadesFiltradas[atividade] = atividades[atividade];
            }
        }
        if (Object.keys(atividadesFiltradas).length > 0) {
            resultado[conjunto] = atividadesFiltradas;
        }
    }
    return resultado;
};
exports.filtrarLogs = filtrarLogs;
